import { useFormikContext } from 'formik';
import { ReactElement } from 'react';
import FormTextbox from '../../../components/FormInputs/FormTextbox/FormTextbox';
import Panel from '../../../components/Panel/Panel';
import { useAppSelector } from '../../../redux/hooks';
import { selectSchoolManagementDataEntryMode } from '../../../redux/slices/schoolManagementSlice';
import { DataEntryMode } from '../../../types/DataEntryMode';
import { PanelType } from '../../../types/PanelType';
import { SchoolManagementModel } from '../../../types/SchoolManagementModel';
import { SchoolManagementValidationSchema } from '../../../types/Validation/SchoolManagementValidationSchema';
import {
  isDistrictAdmin,
  isStateAdmin,
} from '../../../utilities/userUtilities';

const SchoolManagementMSISSchoolContactInformationPanel = (): ReactElement => {
  const { values } = useFormikContext<SchoolManagementModel>();

  const dataEntryMode: DataEntryMode = useAppSelector(
    selectSchoolManagementDataEntryMode
  );

  const shouldHidePanel =
    values.schoolType !== 'Regular School' ||
    ['001', '200', '500'].includes(values.schoolIdentifierSchoolPart);

  if (shouldHidePanel) {
    return <></>;
  }

  const isContactRequired =
    dataEntryMode === DataEntryMode.EDIT ||
    (dataEntryMode === DataEntryMode.NEW && !isStateAdmin());

  return (
    <Panel panelType={PanelType.INFO} heading="MSIS School Contact Information">
      <div className="field-row" data-testid="msis-school-contact-panel">
        <FormTextbox
          displayName="Position Title"
          field="schoolContact.positionTitle"
          validationSchema={SchoolManagementValidationSchema}
          disabled={!isStateAdmin() && !isDistrictAdmin()}
        />
        <FormTextbox
          displayName="First Name"
          field="schoolContact.firstName"
          validationSchema={SchoolManagementValidationSchema}
          disabled={!isStateAdmin() && !isDistrictAdmin()}
          classConfig={{
            labelClasses: isContactRequired ? 'forced-required-label' : '',
          }}
        />
        <FormTextbox
          displayName="Last Name"
          field="schoolContact.lastorSurname"
          validationSchema={SchoolManagementValidationSchema}
          disabled={!isStateAdmin() && !isDistrictAdmin()}
          classConfig={{
            labelClasses: isContactRequired ? 'forced-required-label' : '',
          }}
        />
      </div>
      <div className="field-row">
        <FormTextbox
          displayName="Email Address"
          field="schoolContact.email"
          validationSchema={SchoolManagementValidationSchema}
          disabled={!isStateAdmin() && !isDistrictAdmin()}
        />
        <FormTextbox
          displayName="Telephone Number"
          field="schoolContact.telephoneNumber"
          validationSchema={SchoolManagementValidationSchema}
          disabled={!isStateAdmin() && !isDistrictAdmin()}
          classConfig={{
            labelClasses: isContactRequired ? 'forced-required-label' : '',
          }}
        />
      </div>
    </Panel>
  );
};

export default SchoolManagementMSISSchoolContactInformationPanel;
